<template>
    <v-card class="pt-lg-5 pa-0" :height="screenHeight" v-if="fulldisplay === false">
        <v-card-text
            :style="titleStyle">Calling
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text
            class="callingNo"
            :style="callingStyle"
        >
            {{ callingNo.no }}
            <div v-if="callingNo.counter" :style="_callingCounterStyle"> {{
                    callingNo.counter
                }}
            </div>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-list
        >
            <v-list-item
                v-for="(previousNo,i) in previousNos.slice().reverse()"
                :key="i"
                style="border-top: 1px solid #e2e2e2"
            >
                <v-list-item-content>
                    <v-list-item-title :style="listStyle">{{ previousNo.no }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <div v-if="previousNo.counter" style="text-align: center;font-size: 25px"> {{
                                previousNo.counter
                            }}
                        </div>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
    <div
        v-else
    >
        <v-row class="pl-2">
            <v-col cols="12"
                   lg="9"
                   md="12"
                   sm="12"
                   xs="12"
                   style="padding: 0 0 0 2px" justify="center">
                <v-card tile :height="screenHeight">
                    <div :style="'height: ' + screenHeight/5 + 'px'"></div>
                    <v-card-text :style="titleStyle2">Queue No.</v-card-text>
                    <v-card-text
                        class="callingNo"
                        :style="callingStyle2">{{ callingNo.no }}
                    </v-card-text>
                    <div v-if="callingNo.counter">
                        <v-card-text :style="titleStyle2">Please Proceed To</v-card-text>
                        <v-card-text :style="callingStyle2">{{ callingNo.counter }}</v-card-text>
                    </div>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                lg="3"
                md="12"
                sm="12"
                style="padding: 0 2px 0 0">
                <v-card tile :height="screenHeight">
                    <v-list
                    >
                        <v-list-item
                            v-for="(previousNo,i) in previousNos.slice().reverse()"
                            :key="i"
                            style="border-bottom: 1px solid #e2e2e2"
                        >
                            <v-list-item-content>
                                <v-list-item-title :style="listStyle2">{{ previousNo.no }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <div v-if="previousNo.counter" style="text-align: center;font-size: 45px">
                                        {{ previousNo.counter }}
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            previousNos: [],
            callingNo: [],
        };
    },
    props: ['outlet', 'fulldisplay', 'fontSize', 'callingCounterStyle'],
    computed: {
        titleStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: this.fontSize ? this.fontSize : '40px',
                color: 'black',
            }
        },
        titleStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '60px',
                color: 'black',
            }
        },
        callingStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '70px',
                color: 'red',
                lineHeight: '40px'
            }
        },
        _callingCounterStyle() {
          return this.callingCounterStyle
            ? this.callingCounterStyle
              : {
                'padding-top': '20px',
                'overflow-wrap': 'break-word'
              }
        },
        callingStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '70px',
                color: 'red',
                lineHeight: '60px'
            }
        },
        listStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: 'black',
            }
        },
        listStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '60px',
                color: 'black',
            }
        },
        screenHeight() {
            if (this.fulldisplay === true && !this.outlet.display_missed) {
                return this.outlet.page_rotation === 0 ? window.innerHeight : window.innerWidth;
            } else {
                return this.outlet.display_missed ? '90vh' : '100%'
            }
        }
    },
    methods: {
        playSound() {
            let bell = this.outlet.audio ? new Audio('/storage' + this.outlet.audio) : new Audio('/storage/audios/default.mp3');
            bell.play();
        },
    },
    created: function () {
        Echo.channel('tvcall-channel')
            .listen('.QueueNumberReceived', (e) => {
                console.log(e);
                if (e.outlet_id === this.outlet.id && e.type === 'queue') {
                    this.callingNo = {no: e.queue_number, counter: e.counter_no};
                    this.playSound();
                    // make queue # blinks
                    $('.callingNo').each(function () {
                        var elem = $(this);
                        // count the blinks
                        var count = 1;
                        var intervalId = setInterval(function () {
                            if (elem.css('visibility') == 'hidden') {
                                elem.css('visibility', 'visible');
                                // increment counter when showing to count # of blinks and stop when visible
                                if (count++ === 4) {
                                    clearInterval(intervalId);
                                }
                            } else {
                                elem.css('visibility', 'hidden');
                            }
                        }, 400);
                    });
                }
            })
    },
    watch: {
        callingNo: function (newVal, oldVal) {
            if (oldVal.length !== 0) {
                this.previousNos.push(oldVal);
            }
            if (this.previousNos.length === 5) {
                this.previousNos.shift();
            }
        },
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CallingNumber.vue